var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.69 56.229l19.594 27.42a9.078 9.078 0 0014.36.536L140.84 7.16",
    stroke: "#6BCE62",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.37 25.44C76.072 9.17 41.82 14.62 21.872 38.246c-19.948 23.628-19.568 58.3.893 81.485 20.461 23.185 54.825 27.882 80.76 11.039 25.936-16.843 35.612-50.14 22.74-78.254",
    stroke: "#6BCE62",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSuccessIcon;